import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import type { IGoogleAdsKeyword } from '@feathr/blackbox';
import { Button, Pill } from '@feathr/components';

interface IKeywordButtonProps {
  readonly keyword: IGoogleAdsKeyword;
  readonly onClick?: (keyword: IGoogleAdsKeyword) => void;
  readonly prefix?: ReactNode;
  readonly suffix?: ReactNode;
  readonly name?: string;
}

import * as styles from './KeywordButton.css';

function KeywordButton({
  keyword,
  onClick,
  prefix,
  suffix,
  name,
}: IKeywordButtonProps): JSX.Element {
  function handleKeywordClick(): void {
    onClick?.(keyword);
  }

  return (
    <Button
      className={styles.root}
      name={name ?? keyword.display_name}
      onClick={handleKeywordClick}
      type={'naked'}
    >
      <Pill prefix={prefix} suffix={suffix} variant={'primary'}>
        {keyword.display_name}
      </Pill>
    </Button>
  );
}

export default observer(KeywordButton);
